import {
  CheckoutOrderSummaryLineItemsFields,
  core_apimessages_CheckoutLineItem_Type as CheckoutLineItemType,
} from '../schemas/rql';
import gql from 'graphql-tag';
import React from 'react';

type CheckoutLineItem = CheckoutOrderSummaryLineItemsFields.LineItems;

interface IProps {
  lineItems: CheckoutLineItem[];
}

export default function CheckoutOrderSummaryLineItems(props: IProps) {
  return (
    <table className="checkout-order-summary__line-items">
      <tbody>
        {props.lineItems.map((lineItem) => (
          <CheckoutLineItemRow key={lineItem.type} lineItem={lineItem} />
        ))}
      </tbody>
    </table>
  );
}

function CheckoutLineItemRow({ lineItem }: { lineItem: CheckoutLineItem }) {
  switch (lineItem.type) {
    case CheckoutLineItemType.AMOUNT_CREDIT:
      return (
        <tr className="color-green">
          <td>{lineItem.label}</td>
          <td className="align-right">
            {lineItem.amount.display}
          </td>
        </tr>
      );
    case CheckoutLineItemType.AMOUNT_TAX:
      return (
        <tr>
          <td>
            <span>{lineItem.label}</span>
          </td>
          <td className="align-right valign-top">
            {lineItem.amount.display}
          </td>
        </tr>
      );
    case CheckoutLineItemType.AMOUNT_OWED:
      return (
        <tr>
          <td className="size-fixed-150 weight-bold">Total</td>
          <td className="align-right size-fixed-150 weight-bold color-green">
            {lineItem.amount.display}
            {lineItem.amount.currency !== 'USD' &&
              <span className="price-currency">{lineItem.amount.currency}</span>
            }
          </td>
        </tr>
      );
    default:
      return (
        <tr>
          <td>{lineItem.label}</td>
          <td className="align-right">
            {lineItem.amount.display}
          </td>
        </tr>
      );
  }
}

export const CheckoutOrderSummaryLineItemsFragment = gql`
  fragment CheckoutOrderSummaryLineItemsFields on Checkout {
    _id
    lineItems {
      type
      label
      amount {
        display
        currency
      }
    }
  }
`;
